import React, { useMemo } from 'react';

import { hexToRgb } from 'util/color';
import { getSeedRateColorFromBins } from 'util/formatters/data-viz/seed';
import { getMessage } from 'util/locale';
import { convertForLocaleScalar } from 'util/unitConversion';

import ColorBullet from 'common/ColorBullet';

interface SeedingRate {
  u: string;
  v: number;
}

interface ZoneLabelProps {
  rowIndex: number;
  seedingRate: SeedingRate;
  seedingRateBins: [number, number][];
}

export function ZoneLabel({ rowIndex, seedingRate, seedingRateBins }: ZoneLabelProps) {
  const rgbColor = useMemo(() => {
    const convertedRate = convertForLocaleScalar({
      quantity: seedingRate.v,
      unit: seedingRate.u,
      unitType: 'seed-density'
    });
  
    const hexColor = getSeedRateColorFromBins({ bins: seedingRateBins, rate: convertedRate });
    return hexToRgb(hexColor);
  }, [seedingRateBins, seedingRate.v, seedingRate.u]);

  return (
    <span>
      <ColorBullet color={rgbColor} />
      {`${getMessage('zone')} ${rowIndex + 1}`}
    </span>
  );
}
